import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import calendarUiReducer from './calendarUiReducer';
import calendarDataReducer from './calendarDataReducer';

const uIPersistConfig = {
  key: 'ui',
  storage,
  whitelist: ['isAnalyticsDisabled'],
};

// const dataPersistConfig = {
//   key: 'data',
//   storage,
// };

const calendarReducer = combineReducers({
  data: calendarDataReducer,
  ui: persistReducer(uIPersistConfig, calendarUiReducer),
});

export default calendarReducer;

// import { combineReducers } from 'redux';

// import calendarUiReducer from './calendarUiReducer';
// import calendarDataReducer from './calendarDataReducer';

// export default combineReducers({
//   ui: calendarUiReducer,
//   data: calendarDataReducer,
// });
